import { observer } from 'mobx-react-lite';
import * as R from 'ramda';

import { BaseFormRulesManager } from './BaseFormRulesManagerComponent';

export const BaseFormRulesManagerContainer = R.compose(observer)(BaseFormRulesManager);
